import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme, { layout } from '../../theme.style';

export default mergeStyleSets({
  root: {
    padding: pxToRem(16),
    paddingBottom: pxToRem(24),
    selectors: {
      [layout.breakpoints.min.md]: {
        padding: pxToRem(24),
        paddingBottom: pxToRem(32),
      },
      [layout.breakpoints.min.lg]: {
        paddingLeft: pxToRem(40),
        paddingRight: pxToRem(40),
      },
    },
  },
  isClosed: {
    display: 'none',
  },
  isOpen: {
    borderBottom: `${pxToRem(1)} solid ${theme.palette.neutralQuaternary}`,
  },
  noPadding: {
    padding: 0,
  },
});
